import { IGetPaymentMethodsResult } from './types';

export const DEFAULT_RESULT: IGetPaymentMethodsResult = {
  methods: {},
  methodIds: [],
  selectedMethodId: null,
  paymentProviders: [],
};
